import React, { useContext, useState, useEffect, useRef } from 'react';
import ReactSVG from 'react-svg';
import close from 'times.svg';
import { ListingMapContext } from '../../../context/ListingMapContext.js';
import useOutsideClick from '../../../hooks/useOutsideClick.js';
import WindowQuery from '../../../utils/WindowQuery.js';

export default function CategoryDropdown() {
  const updateQuery = new WindowQuery();
  const dropdownRef = useRef();

  const {
    setMapCategories,
    mapCategories,
    categories,
    setDropdown,
    categoriesVisible,
  } = useContext(ListingMapContext);

  const [localMapCategories, setLocalMapCategories] = useState([]);
  const [sortedCategories, setSortedCategories] = useState(categories);

  useEffect(() => {
    const sorted = categories.sort((a, b) => {
      if (a.name > b.name) return 1;
      if (a.name < b.name) return -1;
      return 0;
    });
    setSortedCategories(sorted);
  }, [categories]);

  useEffect(() => {
    if (mapCategories.length)
      setLocalMapCategories(mapCategories.map(c => c.toLowerCase()));
  }, [mapCategories]);

  useOutsideClick(dropdownRef, categoriesVisible, () => setDropdown(null));

  return (
    <div
      dropdownRef={dropdownRef}
      className="dropdown-sorting-container categories"
    >
      <h2 className="dropdown-title">Categories</h2>
      <section>
        <ReactSVG
          className="dropdown-times"
          src={close}
          onClick={() => {
            setLocalMapCategories(mapCategories);
            setDropdown(null);
          }}
        />
      </section>
      <h2 className="dropdown-section-title" style={{ marginBottom: '20px' }}>
        Categories
      </h2>
      <section
        className="dropdown-sorting-inputs"
        style={{ overflowX: 'auto' }}
      >
        {sortedCategories.map(category => (
          <label key={category.id} htmlFor={`category-type-${category.slug}`}>
            <input
              aria-label={`${category.name}`}
              id={`category-type-${category.slug}`}
              type="checkbox"
              checked={localMapCategories.includes(category.slug)}
              onChange={() => {
                if (localMapCategories.includes(category.slug)) {
                  const mapCategoriesCopy = [...localMapCategories];
                  const index = localMapCategories.findIndex(
                    cur => cur === category.slug
                  );
                  mapCategoriesCopy.splice(index, 1);
                  setLocalMapCategories(mapCategoriesCopy);
                } else {
                  setLocalMapCategories([...localMapCategories, category.slug]);
                }
              }}
            />
            <p>{category.name}</p>
          </label>
        ))}
      </section>
      <section className="dropdown-actions">
        <button
          aria-label="Apply Category Filters"
          name="Apply Category Filters"
          type="button"
          className="btn btn--dark btn--small"
          onClick={() => {
            updateQuery.add(
              'categories',
              localMapCategories.map(c => c.toLowerCase()).join(',')
            );
            setMapCategories(localMapCategories);
            setDropdown(null);
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Category Filters"
          name="Clear Category Filters"
          type="button"
          className="btn btn--light btn--small"
          onClick={() => {
            setMapCategories([]);
            setLocalMapCategories([]);
            updateQuery.remove('categories');
          }}
        >
          Clear
        </button>
      </section>
    </div>
  );
}
